<template>
  <div :class="$style.countdown">
    <template v-if="days">
      {{ days }}{{ $t('day-shorthand') }}
    </template>
    <span
      :class="[$style.digit]"
    >
      {{ hours }}
    </span>
    :
    <span :class="$style.digit">
      {{ minutes }}
    </span>
    <template v-if="days === 0">
      :
      <span :class="$style.digit">
        <template v-if="seconds<10">
          0{{ seconds }}
        </template>
        <template v-else>
          {{ seconds }}
        </template>
      </span>
    </template>
  </div>
</template>

<script>
import { getTime, parse } from 'date-fns'

export default {
  name: 'BaseCountdown',
  props: {
    date: {
      type: [Date, String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      defaultDate: (this.date instanceof Date)
        ? this.date
        : parse(this.date),
      now: Math.trunc((new Date()).getTime() / 1000),
    }
  },
  computed: {
    dateInMilliseconds() {
      return Math.trunc((getTime(this.date)) / 1000)
    },
    seconds() {
      return (this.dateInMilliseconds - this.now) % 60
    },
    minutes() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60
    },
    hours() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24
    },
    days() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24)
    },
  },
  mounted() {
    this.interval = setInterval(() => {
      this.now = Math.trunc((new Date()).getTime() / 1000)
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
}
</script>

<style module lang="scss">
  @import '../../assets/scss/variables';

  .countdown {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: $font-size-xlarge;
    font-weight: 600;
    .digit {
      text-align: center;
      font-weight: 600;
      width: 30px;
      white-space: nowrap;
    }
  }

</style>
